/**
 * @file tipOrderStatus.js
 * @description 打赏订单状态判断（与后端 orderStatus / paymentStatus 对齐）
 * @module features/comic/utils/tipOrderStatus
 */

/**
 * @param {{ orderStatus?: string, paymentStatus?: string } | null | undefined} vo
 * @returns {boolean}
 */
export function isTipOrderPaid(vo) {
  return vo?.orderStatus === 'PAID' && vo?.paymentStatus === 'SUCCESS'
}

/**
 * @param {{ orderStatus?: string, paymentStatus?: string } | null | undefined} vo
 * @returns {boolean}
 */
export function isTipOrderClosed(vo) {
  if (!vo) return false
  if (vo.orderStatus === 'CLOSED' || vo.orderStatus === 'CANCELLED') return true
  return vo.paymentStatus === 'CLOSED' || vo.paymentStatus === 'PAYERROR'
}

/**
 * 分转元展示
 * @param {number} cent
 * @returns {number}
 */
export function centToYuan(cent) {
  const n = Number(cent)
  if (!Number.isFinite(n)) return 0
  return n / 100
}
